import * as React from 'react';
import { Box } from '@mui/material';

// A chat bubble: right-aligned primary for the user, left-aligned grey for everyone else.
export function Bubble({ isUser, children }: { isUser: boolean; children: React.ReactNode }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', mb: 2 }}>
      <Box
        sx={{
          maxWidth: '80%',
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: 'grey.100',
          color: 'text.primary',
          overflowWrap: 'anywhere',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
